<template lang="html">
    <div class="toolbar-search">
        <z-date placeholder="Начальная дата" ref="datefrom" v-model="filter.date_from" light></z-date>
        <z-date placeholder="Конечная дата"  ref="datefrom" v-model="filter.date_to"   light></z-date>

        <z-select v-model="filter.module_id" light>
            <option value="">Модуль (все)</option>
            <option v-for="module in modules" v-bind:value="module.id" v-bind:key="module.id"> {{ module.description }}</option>
        </z-select>

        <z-button danger-light  v-on:click="onRemove" v-bind:disabled="!hasFilter">Удалить</z-button>
        <z-button primary-light v-on:click="onFilter" v-bind:disabled="!hasFilter">Показать</z-button>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset" v-bind:disabled="!hasFilter"></z-icon-button>
    </div>
</template>
<script>
    import ZDate   from '@/components/ZDate';
    import ZButton from '@/components/ZButton.vue';
    import ZSelect from '@/components/ZSelect.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { ZIconButton, ZButton, ZSelect, ZDate },
        data() {
            return {
                filterDefault: {},
                filter: {
                    date_from: null,
                    date_to: null,
                    module_id: ''
                }
            }
        },
        computed: {
            /**
             * Список модулей в системе, полученный с бэка
             */
            modules() {
                return this.$store.state.module.modules;
            },
            /**
             * Флаг, показывающий, есть ли в фильтре хотябы одно значение
             */
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            }
        },
        created() {
            this.filterDefault = Object.assign({}, this.filter);
            this.resolveQueryFilter();
            this.getModules();
        },
        methods: {
            /**
             * Преобразует фильтр в URL в объект для работы с фильтрацией
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Вызывается по событию сброса фильтра
             * сбрасывает фильтр в URL и обновляет таблицу логов
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query:  Object.assign({}, query)
                });
                this.$root.$emit('reload-table', 'logs-list');
            },
            /**
             * Вызывается по событию фильтрации
             * устанавливает фильтр в URL и обновляет таблицу логов
             */
            onFilter() {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });

                this.$root.$emit('reload-table', 'logs-list');
            },
            /**
             * Вызывается по событию удаления логов
             * удаляет логи в указанном промежутке дат и сбрасывает фильтр
             */
            onRemove() {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении записей?', 'Действие необратимо!',
                    () => {
                        let from = this.filter.date_from ? this.moment(this.filter.date_from).format('YYYY-MM-DD') : null,
                            to   = this.filter.date_to   ? this.moment(this.filter.date_to).format('YYYY-MM-DD')   : null;

                        this.$store.dispatch('logs/removeLogByDate', {from: from, to: to}).then(() => this.resetFilter());
                    }
                );
            },
            /**
             * Запрашивает с бэка список модулей системы для фильтрации
             */
            getModules() {
                return this.$store.dispatch('module/getModules');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SearchToolbar.vue?eaa5e222